import { throwError } from "../../lib/throwError";
import { get } from "../axiosUitils";

const basePath = "/city_collab/donations";

export interface UserDonation {
  membership_number: string | null;
  event_id: string;
  donation_id: string;
  name: string;
  email: string;
  phone: string;
  donation_amount: string;
  category: string;
  donation_title: string;
  donation_date: string;
  paid_method: string | null;
  transaction_id: string | null;
  status: string;
  organization_id: string;
}

interface UserDonationResponse {
  success: {
    code: string;
    message: string;
  };
  data: UserDonation[];
}

class DonationService {
  /**
   * Get login user donations
   */
  getLoginUserDonations = async (
    notifyMessage?: boolean
  ): Promise<UserDonation[]> => {
    try {
      const response = await get<UserDonationResponse>(
        `${basePath}/login-user-donation-list/`,
        {
          notifyMessage,
        }
      );

      if (response?.success && response?.data) {
        return response.data;
      }

      return [];
    } catch (error) {
      console.log(error);
      throwError("Failed to fetch user donations", "DonationService");
      return [];
    }
  };
}

const instance = new DonationService();
export default instance;
